"use no memo";

import Cookies from 'universal-cookie';

import { isMarketplacePlatform, isYelpPlatform } from '@local/utils';

import { PLATFORM } from 'helpers/constants';
import { is, includes } from 'helpers/partial';

export const isChowNow = includes([PLATFORM.direct, PLATFORM.marketplace]);

export const isStandardPayment = isChowNow;

export const isDirect = is(PLATFORM.direct);

export const isMarketplace = is(PLATFORM.marketplace);

export const isYelp = is(PLATFORM.yelp);

export function validatePlatform(platform) {
  if (platform in PLATFORM) {
    return platform;
  }

  return null;
}

export function getPlatformName() {
  const cookies = new Cookies();
  if (isMarketplacePlatform()) {
    return PLATFORM.marketplace;
  }

  if (isYelpPlatform()) {
    return PLATFORM.yelp;
  }

  return validatePlatform(cookies.get('cn_platform')) || PLATFORM.direct;
}

export function getAdsPlatform(isObn) {
  if (isObn) {
    return 'obn';
  }
  return isMarketplacePlatform() ? 'marketplace' : 'direct';
}
